export default function videoPlayerModal(options = {}) {
    const defaults = {
        mobileBreakpoint: 768,
        desktopVideos: [
            {
                src: "https://d1axg9pbn00pk6.cloudfront.net/home/HomeHero_H265_1M.mp4",
                type: "video/mp4; codecs=avc1.4D401E",
            },
        ],
        mobileVideos: [
            {
                src: "https://d1axg9pbn00pk6.cloudfront.net/home/HomeHero_H265_1M.mp4",
                type: "video/mp4; codecs=avc1.4D401E",
            },
        ],
    };

    const config = { ...defaults, ...options };

    return {
        showModal: false,
        isMobile: false,
        desktopVideos: config.desktopVideos,
        mobileVideos: config.mobileVideos,
        mobileBreakpoint: config.mobileBreakpoint,

        init() {
            this.checkScreenSize();
            this.setupEventListeners();
        },

        setupEventListeners() {
            const boundCheckScreenSize = this.checkScreenSize.bind(this);
            window.addEventListener("resize", boundCheckScreenSize);

            // Clean up on component destroy (if using with frameworks)
            if (this.$cleanup) {
                this.$cleanup = () => {
                    window.removeEventListener("resize", boundCheckScreenSize);
                };
            }
        },

        get videoSources() {
            return this.isMobile ? this.mobileVideos : this.desktopVideos;
        },

        togglePlay() {
            const videoEl = this.$refs.video;
            if (videoEl) {
                videoEl.play().catch((err) => {
                    console.warn("Could not autoplay video:", err);
                });
            }
        },

        handleExit() {
            const videoEl = this.$refs.video;
            if (videoEl) {
                videoEl.pause();
                videoEl.currentTime = 0;
            }
        },

        openModal() {
            this.showModal = true;
            this.$nextTick(() => this.togglePlay());
        },

        closeModal() {
            this.showModal = false;
            this.handleExit();
        },

        checkScreenSize() {
            const wasMobile = this.isMobile;
            this.isMobile = window.innerWidth < this.mobileBreakpoint;

            // If screen size category changed and video is loaded, reload with new sources
            if (wasMobile !== this.isMobile && this.$refs.video) {
                const currentTime = this.$refs.video.currentTime;
                const wasPlaying = !this.$refs.video.paused;
                this.$refs.video.load();
                this.$refs.video.currentTime = currentTime;
                if (wasPlaying) this.$refs.video.play();
            }
        },
    };
}
